//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const OM_BATCH_API_BASE_URL = new InjectionToken<string>('OM_BATCH_API_BASE_URL');

export class ServiceBaseConfig {
  public key: string;
}

export class ServiceBase {
  private readonly apiKey: string;
  private readonly apimHeaderName: string = 'Ocp-Apim-Subscription-Key';
  private readonly tenantIdHeaderName: string = 'TenantId';
  private readonly tenantIdLocalStorageKey: string = 'samplicity-dtp-current-client';
  private readonly idTokenKey: string = 'samplicity-id-token';

  constructor(config: ServiceBaseConfig) {
    this.apiKey = config.key;
  }

  protected transformOptions(options: any) {
    let headers: HttpHeaders = options.headers;

    if (this.apiKey) {
      headers = headers.append(this.apimHeaderName, this.apiKey);
    }

    const tenantId = sessionStorage.getItem(this.tenantIdLocalStorageKey);
    if (tenantId) {
      headers = headers.append(this.tenantIdHeaderName, tenantId);
    }

    const token = localStorage.getItem(this.idTokenKey);
    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }

    options.headers = headers;

    return Promise.resolve(options);
  }
}

@Injectable()
export class OrderManagementBatch extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ServiceBaseConfig) configuration: ServiceBaseConfig, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(OM_BATCH_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getBatches(input?: BatchListSearchFilterDto | null | undefined): Observable<AjaxResponseOfPagedResultOfBatchListDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetBatches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPagedResultOfBatchListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPagedResultOfBatchListDto>;
        }));
    }

    protected processGetBatches(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfBatchListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPagedResultOfBatchListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dto (optional) 
     * @return Success
     */
    createBatch(dto?: BatchSetupDto | null | undefined): Observable<AjaxResponseOfBatchSetupDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/CreateBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchSetupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchSetupDto>;
        }));
    }

    protected processCreateBatch(response: HttpResponseBase): Observable<AjaxResponseOfBatchSetupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchSetupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNewBatch(): Observable<AjaxResponseOfBatchSetupDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetNewBatch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNewBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchSetupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchSetupDto>;
        }));
    }

    protected processGetNewBatch(response: HttpResponseBase): Observable<AjaxResponseOfBatchSetupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchSetupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBatch(id?: string | null | undefined): Observable<AjaxResponseOfBatchSetupDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetBatch?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchSetupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchSetupDto>;
        }));
    }

    protected processGetBatch(response: HttpResponseBase): Observable<AjaxResponseOfBatchSetupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchSetupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dto (optional) 
     * @return Success
     */
    updateBatch(dto?: BatchSetupDto | null | undefined): Observable<AjaxResponseOfBatchSetupDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/UpdateBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchSetupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchSetupDto>;
        }));
    }

    protected processUpdateBatch(response: HttpResponseBase): Observable<AjaxResponseOfBatchSetupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchSetupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dto (optional) 
     * @return Success
     */
    updateBatchExecutionData(dto?: BatchSetupDto | null | undefined): Observable<AjaxResponse> {
        let url_ = this.baseUrl + "/api/services/app/Batch/UpdateBatchExecutionData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBatchExecutionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBatchExecutionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponse>;
        }));
    }

    protected processUpdateBatchExecutionData(response: HttpResponseBase): Observable<AjaxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    getBatchExecutionDetails(batchId?: string | null | undefined): Observable<AjaxResponseOfBatchExecutionDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetBatchExecutionDetails?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBatchExecutionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchExecutionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchExecutionDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchExecutionDetailsDto>;
        }));
    }

    protected processGetBatchExecutionDetails(response: HttpResponseBase): Observable<AjaxResponseOfBatchExecutionDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchExecutionDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBatchSummary(id?: string | null | undefined): Observable<AjaxResponseOfBatchSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetBatchSummary?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBatchSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchSummaryDto>;
        }));
    }

    protected processGetBatchSummary(response: HttpResponseBase): Observable<AjaxResponseOfBatchSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchid (optional) 
     * @param packagetypeid (optional) 
     * @return Success
     */
    getBatchPackageExecutionDetails(batchid?: string | null | undefined, packagetypeid?: string | null | undefined): Observable<AjaxResponseOfBatchPackageExecutionDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetBatchPackageExecutionDetails?";
        if (batchid !== undefined && batchid !== null)
            url_ += "batchid=" + encodeURIComponent("" + batchid) + "&";
        if (packagetypeid !== undefined && packagetypeid !== null)
            url_ += "packagetypeid=" + encodeURIComponent("" + packagetypeid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBatchPackageExecutionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchPackageExecutionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchPackageExecutionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchPackageExecutionDto>;
        }));
    }

    protected processGetBatchPackageExecutionDetails(response: HttpResponseBase): Observable<AjaxResponseOfBatchPackageExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchPackageExecutionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchId (optional) 
     * @param pacakgeDefinitionId (optional) 
     * @return Success
     */
    closePackage(batchId?: string | null | undefined, pacakgeDefinitionId?: string | null | undefined): Observable<AjaxResponseOfBatchPackageExecutionDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/ClosePackage?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        if (pacakgeDefinitionId !== undefined && pacakgeDefinitionId !== null)
            url_ += "pacakgeDefinitionId=" + encodeURIComponent("" + pacakgeDefinitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processClosePackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClosePackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchPackageExecutionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchPackageExecutionDto>;
        }));
    }

    protected processClosePackage(response: HttpResponseBase): Observable<AjaxResponseOfBatchPackageExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchPackageExecutionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param duplicateSerialNoCheckRequestDto (optional) 
     * @return Success
     */
    checkForDuplicates(duplicateSerialNoCheckRequestDto?: DuplicateSerialNoCheckRequestDto | null | undefined): Observable<AjaxResponseOfBatchDuplicateCheckDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/CheckForDuplicates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(duplicateSerialNoCheckRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckForDuplicates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckForDuplicates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchDuplicateCheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchDuplicateCheckDto>;
        }));
    }

    protected processCheckForDuplicates(response: HttpResponseBase): Observable<AjaxResponseOfBatchDuplicateCheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchDuplicateCheckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param scanDto (optional) 
     * @return Success
     */
    recordPakageScanForBatch(scanDto?: PackageScanDto | null | undefined): Observable<AjaxResponse> {
        let url_ = this.baseUrl + "/api/services/app/Batch/RecordPakageScanForBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scanDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRecordPakageScanForBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordPakageScanForBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponse>;
        }));
    }

    protected processRecordPakageScanForBatch(response: HttpResponseBase): Observable<AjaxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param packageDefinitionId (optional) 
     * @return Success
     */
    markAsException(packageDefinitionId?: string | null | undefined): Observable<AjaxResponse> {
        let url_ = this.baseUrl + "/api/services/app/Batch/MarkAsException?";
        if (packageDefinitionId !== undefined && packageDefinitionId !== null)
            url_ += "packageDefinitionId=" + encodeURIComponent("" + packageDefinitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponse>;
        }));
    }

    protected processMarkAsException(response: HttpResponseBase): Observable<AjaxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    addNewPackForBatch(batchId?: string | null | undefined): Observable<AjaxResponseOfBatchPackageExecutionDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/AddNewPackForBatch?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddNewPackForBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPackForBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfBatchPackageExecutionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfBatchPackageExecutionDto>;
        }));
    }

    protected processAddNewPackForBatch(response: HttpResponseBase): Observable<AjaxResponseOfBatchPackageExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfBatchPackageExecutionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    addNewPackagesForBatch(batchId?: string | null | undefined): Observable<AjaxResponse> {
        let url_ = this.baseUrl + "/api/services/app/Batch/AddNewPackagesForBatch?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddNewPackagesForBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPackagesForBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponse>;
        }));
    }

    protected processAddNewPackagesForBatch(response: HttpResponseBase): Observable<AjaxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getBatchExecutionDetailSummary(batchId?: string | null | undefined, tenantId?: number | null | undefined): Observable<PackageExecutionDetailSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetBatchExecutionDetailSummary?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBatchExecutionDetailSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchExecutionDetailSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageExecutionDetailSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageExecutionDetailSummaryDto>;
        }));
    }

    protected processGetBatchExecutionDetailSummary(response: HttpResponseBase): Observable<PackageExecutionDetailSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageExecutionDetailSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchDuplicateCheckDto (optional) 
     * @return Success
     */
    discardDuplicatePackageDetails(batchDuplicateCheckDto?: BatchDuplicateCheckDto | null | undefined): Observable<AjaxResponse> {
        let url_ = this.baseUrl + "/api/services/app/Batch/DiscardDuplicatePackageDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batchDuplicateCheckDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDiscardDuplicatePackageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscardDuplicatePackageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponse>;
        }));
    }

    protected processDiscardDuplicatePackageDetails(response: HttpResponseBase): Observable<AjaxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param parentPackageDefinitionId (optional) 
     * @return Success
     */
    getAllPackageDetails(parentPackageDefinitionId?: string | null | undefined): Observable<AjaxResponseOfListOfDuplicateValidationResult> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetAllPackageDetails?";
        if (parentPackageDefinitionId !== undefined && parentPackageDefinitionId !== null)
            url_ += "parentPackageDefinitionId=" + encodeURIComponent("" + parentPackageDefinitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPackageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPackageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfDuplicateValidationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfDuplicateValidationResult>;
        }));
    }

    protected processGetAllPackageDetails(response: HttpResponseBase): Observable<AjaxResponseOfListOfDuplicateValidationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfDuplicateValidationResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param batchId (optional) 
     * @return Success
     */
    deleteBatch(batchId?: string | null | undefined): Observable<AjaxResponse> {
        let url_ = this.baseUrl + "/api/services/app/Batch/DeleteBatch?";
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponse>;
        }));
    }

    protected processDeleteBatch(response: HttpResponseBase): Observable<AjaxResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class BatchListSearchFilterDto implements IBatchListSearchFilterDto {
    batch_Number: string | undefined;
    batch_LotNumber: string | undefined;
    batch_StatusClassificationIds: string[] | undefined;
    creationStartTime: Date | undefined;
    creationEndTime: Date | undefined;
    palletSscc: string | undefined;
    shipperCase_Gtin: string | undefined;
    pack_Gtin: string | undefined;
    innerPack_Gtin: string | undefined;
    productGtin: string | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    sortBy: string | undefined;
    filterString: string | undefined;

    constructor(data?: IBatchListSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch_Number = _data["batch_Number"];
            this.batch_LotNumber = _data["batch_LotNumber"];
            if (Array.isArray(_data["batch_StatusClassificationIds"])) {
                this.batch_StatusClassificationIds = [] as any;
                for (let item of _data["batch_StatusClassificationIds"])
                    this.batch_StatusClassificationIds.push(item);
            }
            this.creationStartTime = _data["creationStartTime"] ? new Date(_data["creationStartTime"].toString()) : <any>undefined;
            this.creationEndTime = _data["creationEndTime"] ? new Date(_data["creationEndTime"].toString()) : <any>undefined;
            this.palletSscc = _data["palletSscc"];
            this.shipperCase_Gtin = _data["shipperCase_Gtin"];
            this.pack_Gtin = _data["pack_Gtin"];
            this.innerPack_Gtin = _data["innerPack_Gtin"];
            this.productGtin = _data["productGtin"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.sortBy = _data["sortBy"];
            this.filterString = _data["filterString"];
        }
    }

    static fromJS(data: any): BatchListSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchListSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch_Number"] = this.batch_Number;
        data["batch_LotNumber"] = this.batch_LotNumber;
        if (Array.isArray(this.batch_StatusClassificationIds)) {
            data["batch_StatusClassificationIds"] = [];
            for (let item of this.batch_StatusClassificationIds)
                data["batch_StatusClassificationIds"].push(item);
        }
        data["creationStartTime"] = this.creationStartTime ? this.creationStartTime.toISOString() : <any>undefined;
        data["creationEndTime"] = this.creationEndTime ? this.creationEndTime.toISOString() : <any>undefined;
        data["palletSscc"] = this.palletSscc;
        data["shipperCase_Gtin"] = this.shipperCase_Gtin;
        data["pack_Gtin"] = this.pack_Gtin;
        data["innerPack_Gtin"] = this.innerPack_Gtin;
        data["productGtin"] = this.productGtin;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["sortBy"] = this.sortBy;
        data["filterString"] = this.filterString;
        return data;
    }

    clone(): BatchListSearchFilterDto {
        const json = this.toJSON();
        let result = new BatchListSearchFilterDto();
        result.init(json);
        return result;
    }
}

export interface IBatchListSearchFilterDto {
    batch_Number: string | undefined;
    batch_LotNumber: string | undefined;
    batch_StatusClassificationIds: string[] | undefined;
    creationStartTime: Date | undefined;
    creationEndTime: Date | undefined;
    palletSscc: string | undefined;
    shipperCase_Gtin: string | undefined;
    pack_Gtin: string | undefined;
    innerPack_Gtin: string | undefined;
    productGtin: string | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    sortBy: string | undefined;
    filterString: string | undefined;
}

export class AjaxResponseOfPagedResultOfBatchListDto implements IAjaxResponseOfPagedResultOfBatchListDto {
    result: PagedResultOfBatchListDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfPagedResultOfBatchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PagedResultOfBatchListDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfPagedResultOfBatchListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfPagedResultOfBatchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfPagedResultOfBatchListDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfPagedResultOfBatchListDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfPagedResultOfBatchListDto {
    result: PagedResultOfBatchListDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class PagedResultOfBatchListDto implements IPagedResultOfBatchListDto {
    totalCount: number | undefined;
    items: BatchListDto[] | undefined;

    constructor(data?: IPagedResultOfBatchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BatchListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfBatchListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfBatchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultOfBatchListDto {
        const json = this.toJSON();
        let result = new PagedResultOfBatchListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfBatchListDto {
    totalCount: number | undefined;
    items: BatchListDto[] | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class BatchListDto implements IBatchListDto {
    batch_Id: string | undefined;
    batch_Number: string | undefined;
    packageNumber: number | undefined;
    batch_LotNumber: string | undefined;
    expirationDate: Date | undefined;
    createdBy: number | undefined;
    createdByName: string | undefined;
    creationTime: Date | undefined;
    executedBy: number | undefined;
    executedByName: string | undefined;
    batchStatus: string | undefined;
    batch_StatusClassificationId: string | undefined;
    item_gtin: string | undefined;
    pack_gtin: string | undefined;
    case_gtin: string | undefined;
    pallet_sscc: string | undefined;
    batch_lot: string | undefined;

    constructor(data?: IBatchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch_Id = _data["batch_Id"];
            this.batch_Number = _data["batch_Number"];
            this.packageNumber = _data["packageNumber"];
            this.batch_LotNumber = _data["batch_LotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.executedBy = _data["executedBy"];
            this.executedByName = _data["executedByName"];
            this.batchStatus = _data["batchStatus"];
            this.batch_StatusClassificationId = _data["batch_StatusClassificationId"];
            this.item_gtin = _data["item_gtin"];
            this.pack_gtin = _data["pack_gtin"];
            this.case_gtin = _data["case_gtin"];
            this.pallet_sscc = _data["pallet_sscc"];
            this.batch_lot = _data["batch_lot"];
        }
    }

    static fromJS(data: any): BatchListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch_Id"] = this.batch_Id;
        data["batch_Number"] = this.batch_Number;
        data["packageNumber"] = this.packageNumber;
        data["batch_LotNumber"] = this.batch_LotNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["executedBy"] = this.executedBy;
        data["executedByName"] = this.executedByName;
        data["batchStatus"] = this.batchStatus;
        data["batch_StatusClassificationId"] = this.batch_StatusClassificationId;
        data["item_gtin"] = this.item_gtin;
        data["pack_gtin"] = this.pack_gtin;
        data["case_gtin"] = this.case_gtin;
        data["pallet_sscc"] = this.pallet_sscc;
        data["batch_lot"] = this.batch_lot;
        return data;
    }

    clone(): BatchListDto {
        const json = this.toJSON();
        let result = new BatchListDto();
        result.init(json);
        return result;
    }
}

export interface IBatchListDto {
    batch_Id: string | undefined;
    batch_Number: string | undefined;
    packageNumber: number | undefined;
    batch_LotNumber: string | undefined;
    expirationDate: Date | undefined;
    createdBy: number | undefined;
    createdByName: string | undefined;
    creationTime: Date | undefined;
    executedBy: number | undefined;
    executedByName: string | undefined;
    batchStatus: string | undefined;
    batch_StatusClassificationId: string | undefined;
    item_gtin: string | undefined;
    pack_gtin: string | undefined;
    case_gtin: string | undefined;
    pallet_sscc: string | undefined;
    batch_lot: string | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class BatchSetupDto implements IBatchSetupDto {
    batch_Id: string | undefined;
    batch_Number: string | undefined;
    packageNumber: number | undefined;
    batch_Gtin: string | undefined;
    batch_MaxQty: number | undefined;
    batch_LotNumber: string | undefined;
    batch_ExpirationDate: Date | undefined;
    batch_StatusClassificationId: string | undefined;
    batch_SenderSgln: string | undefined;
    batch_KnipperSgln: string | undefined;
    batch_ProcessingStation: string | undefined;
    batch_FileNetworkPathLocation: string | undefined;
    batch_SerialNumberLength: number | undefined;
    batch_Client: number | undefined;
    batch_CreatedBy: number | undefined;
    batch_ExecutedBy: number | undefined;
    batch_CreateDateTime: Date | undefined;
    batch_ExecuteDateTime: Date | undefined;
    batch_PackageNumber: number | undefined;
    pallet_Id: string | undefined;
    pallet_SSCCLeftDigit: string | undefined;
    pallet_MaxQty: number | undefined;
    pallet_SSCCPrefix: string | undefined;
    shipperCase_Id: string | undefined;
    shipperCase_MaxQty: number | undefined;
    shipperCase_Gtin: string | undefined;
    pack_Id: string | undefined;
    pack_Gtin: string | undefined;
    pack_MaxQty: number | undefined;
    item_Id: string | undefined;
    item_Gtin: string | undefined;

    constructor(data?: IBatchSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch_Id = _data["batch_Id"];
            this.batch_Number = _data["batch_Number"];
            this.packageNumber = _data["packageNumber"];
            this.batch_Gtin = _data["batch_Gtin"];
            this.batch_MaxQty = _data["batch_MaxQty"];
            this.batch_LotNumber = _data["batch_LotNumber"];
            this.batch_ExpirationDate = _data["batch_ExpirationDate"] ? new Date(_data["batch_ExpirationDate"].toString()) : <any>undefined;
            this.batch_StatusClassificationId = _data["batch_StatusClassificationId"];
            this.batch_SenderSgln = _data["batch_SenderSgln"];
            this.batch_KnipperSgln = _data["batch_KnipperSgln"];
            this.batch_ProcessingStation = _data["batch_ProcessingStation"];
            this.batch_FileNetworkPathLocation = _data["batch_FileNetworkPathLocation"];
            this.batch_SerialNumberLength = _data["batch_SerialNumberLength"];
            this.batch_Client = _data["batch_Client"];
            this.batch_CreatedBy = _data["batch_CreatedBy"];
            this.batch_ExecutedBy = _data["batch_ExecutedBy"];
            this.batch_CreateDateTime = _data["batch_CreateDateTime"] ? new Date(_data["batch_CreateDateTime"].toString()) : <any>undefined;
            this.batch_ExecuteDateTime = _data["batch_ExecuteDateTime"] ? new Date(_data["batch_ExecuteDateTime"].toString()) : <any>undefined;
            this.batch_PackageNumber = _data["batch_PackageNumber"];
            this.pallet_Id = _data["pallet_Id"];
            this.pallet_SSCCLeftDigit = _data["pallet_SSCCLeftDigit"];
            this.pallet_MaxQty = _data["pallet_MaxQty"];
            this.pallet_SSCCPrefix = _data["pallet_SSCCPrefix"];
            this.shipperCase_Id = _data["shipperCase_Id"];
            this.shipperCase_MaxQty = _data["shipperCase_MaxQty"];
            this.shipperCase_Gtin = _data["shipperCase_Gtin"];
            this.pack_Id = _data["pack_Id"];
            this.pack_Gtin = _data["pack_Gtin"];
            this.pack_MaxQty = _data["pack_MaxQty"];
            this.item_Id = _data["item_Id"];
            this.item_Gtin = _data["item_Gtin"];
        }
    }

    static fromJS(data: any): BatchSetupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch_Id"] = this.batch_Id;
        data["batch_Number"] = this.batch_Number;
        data["packageNumber"] = this.packageNumber;
        data["batch_Gtin"] = this.batch_Gtin;
        data["batch_MaxQty"] = this.batch_MaxQty;
        data["batch_LotNumber"] = this.batch_LotNumber;
        data["batch_ExpirationDate"] = this.batch_ExpirationDate ? this.batch_ExpirationDate.toISOString() : <any>undefined;
        data["batch_StatusClassificationId"] = this.batch_StatusClassificationId;
        data["batch_SenderSgln"] = this.batch_SenderSgln;
        data["batch_KnipperSgln"] = this.batch_KnipperSgln;
        data["batch_ProcessingStation"] = this.batch_ProcessingStation;
        data["batch_FileNetworkPathLocation"] = this.batch_FileNetworkPathLocation;
        data["batch_SerialNumberLength"] = this.batch_SerialNumberLength;
        data["batch_Client"] = this.batch_Client;
        data["batch_CreatedBy"] = this.batch_CreatedBy;
        data["batch_ExecutedBy"] = this.batch_ExecutedBy;
        data["batch_CreateDateTime"] = this.batch_CreateDateTime ? this.batch_CreateDateTime.toISOString() : <any>undefined;
        data["batch_ExecuteDateTime"] = this.batch_ExecuteDateTime ? this.batch_ExecuteDateTime.toISOString() : <any>undefined;
        data["batch_PackageNumber"] = this.batch_PackageNumber;
        data["pallet_Id"] = this.pallet_Id;
        data["pallet_SSCCLeftDigit"] = this.pallet_SSCCLeftDigit;
        data["pallet_MaxQty"] = this.pallet_MaxQty;
        data["pallet_SSCCPrefix"] = this.pallet_SSCCPrefix;
        data["shipperCase_Id"] = this.shipperCase_Id;
        data["shipperCase_MaxQty"] = this.shipperCase_MaxQty;
        data["shipperCase_Gtin"] = this.shipperCase_Gtin;
        data["pack_Id"] = this.pack_Id;
        data["pack_Gtin"] = this.pack_Gtin;
        data["pack_MaxQty"] = this.pack_MaxQty;
        data["item_Id"] = this.item_Id;
        data["item_Gtin"] = this.item_Gtin;
        return data;
    }

    clone(): BatchSetupDto {
        const json = this.toJSON();
        let result = new BatchSetupDto();
        result.init(json);
        return result;
    }
}

export interface IBatchSetupDto {
    batch_Id: string | undefined;
    batch_Number: string | undefined;
    packageNumber: number | undefined;
    batch_Gtin: string | undefined;
    batch_MaxQty: number | undefined;
    batch_LotNumber: string | undefined;
    batch_ExpirationDate: Date | undefined;
    batch_StatusClassificationId: string | undefined;
    batch_SenderSgln: string | undefined;
    batch_KnipperSgln: string | undefined;
    batch_ProcessingStation: string | undefined;
    batch_FileNetworkPathLocation: string | undefined;
    batch_SerialNumberLength: number | undefined;
    batch_Client: number | undefined;
    batch_CreatedBy: number | undefined;
    batch_ExecutedBy: number | undefined;
    batch_CreateDateTime: Date | undefined;
    batch_ExecuteDateTime: Date | undefined;
    batch_PackageNumber: number | undefined;
    pallet_Id: string | undefined;
    pallet_SSCCLeftDigit: string | undefined;
    pallet_MaxQty: number | undefined;
    pallet_SSCCPrefix: string | undefined;
    shipperCase_Id: string | undefined;
    shipperCase_MaxQty: number | undefined;
    shipperCase_Gtin: string | undefined;
    pack_Id: string | undefined;
    pack_Gtin: string | undefined;
    pack_MaxQty: number | undefined;
    item_Id: string | undefined;
    item_Gtin: string | undefined;
}

export class AjaxResponseOfBatchSetupDto implements IAjaxResponseOfBatchSetupDto {
    result: BatchSetupDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfBatchSetupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? BatchSetupDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfBatchSetupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfBatchSetupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfBatchSetupDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfBatchSetupDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfBatchSetupDto {
    result: BatchSetupDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponse implements IAjaxResponse {
    result: any | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponse {
        const json = this.toJSON();
        let result = new AjaxResponse();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponse {
    result: any | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfBatchExecutionDetailsDto implements IAjaxResponseOfBatchExecutionDetailsDto {
    result: BatchExecutionDetailsDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfBatchExecutionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? BatchExecutionDetailsDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfBatchExecutionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfBatchExecutionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfBatchExecutionDetailsDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfBatchExecutionDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfBatchExecutionDetailsDto {
    result: BatchExecutionDetailsDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class BatchExecutionDetailsDto implements IBatchExecutionDetailsDto {
    batch_number: string | undefined;
    packageNumber: number | undefined;
    isAllPackClosed: boolean | undefined;
    isAllShipperCaseClosed: boolean | undefined;
    isAllPalletClosed: boolean | undefined;

    constructor(data?: IBatchExecutionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch_number = _data["batch_number"];
            this.packageNumber = _data["packageNumber"];
            this.isAllPackClosed = _data["isAllPackClosed"];
            this.isAllShipperCaseClosed = _data["isAllShipperCaseClosed"];
            this.isAllPalletClosed = _data["isAllPalletClosed"];
        }
    }

    static fromJS(data: any): BatchExecutionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchExecutionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch_number"] = this.batch_number;
        data["packageNumber"] = this.packageNumber;
        data["isAllPackClosed"] = this.isAllPackClosed;
        data["isAllShipperCaseClosed"] = this.isAllShipperCaseClosed;
        data["isAllPalletClosed"] = this.isAllPalletClosed;
        return data;
    }

    clone(): BatchExecutionDetailsDto {
        const json = this.toJSON();
        let result = new BatchExecutionDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IBatchExecutionDetailsDto {
    batch_number: string | undefined;
    packageNumber: number | undefined;
    isAllPackClosed: boolean | undefined;
    isAllShipperCaseClosed: boolean | undefined;
    isAllPalletClosed: boolean | undefined;
}

export class AjaxResponseOfBatchSummaryDto implements IAjaxResponseOfBatchSummaryDto {
    result: BatchSummaryDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfBatchSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? BatchSummaryDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfBatchSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfBatchSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfBatchSummaryDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfBatchSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfBatchSummaryDto {
    result: BatchSummaryDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class BatchSummaryDto implements IBatchSummaryDto {
    batch_Number: string | undefined;
    processingStartTime: Date | undefined;
    processingEndTime: Date | undefined;
    executedBy: string | undefined;
    totalProducts: number | undefined;
    totalPacks: number | undefined;
    totalShipperCases: number | undefined;
    totalPallets: number | undefined;
    client: string | undefined;
    isBatchFileExported: boolean | undefined;

    constructor(data?: IBatchSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batch_Number = _data["batch_Number"];
            this.processingStartTime = _data["processingStartTime"] ? new Date(_data["processingStartTime"].toString()) : <any>undefined;
            this.processingEndTime = _data["processingEndTime"] ? new Date(_data["processingEndTime"].toString()) : <any>undefined;
            this.executedBy = _data["executedBy"];
            this.totalProducts = _data["totalProducts"];
            this.totalPacks = _data["totalPacks"];
            this.totalShipperCases = _data["totalShipperCases"];
            this.totalPallets = _data["totalPallets"];
            this.client = _data["client"];
            this.isBatchFileExported = _data["isBatchFileExported"];
        }
    }

    static fromJS(data: any): BatchSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batch_Number"] = this.batch_Number;
        data["processingStartTime"] = this.processingStartTime ? this.processingStartTime.toISOString() : <any>undefined;
        data["processingEndTime"] = this.processingEndTime ? this.processingEndTime.toISOString() : <any>undefined;
        data["executedBy"] = this.executedBy;
        data["totalProducts"] = this.totalProducts;
        data["totalPacks"] = this.totalPacks;
        data["totalShipperCases"] = this.totalShipperCases;
        data["totalPallets"] = this.totalPallets;
        data["client"] = this.client;
        data["isBatchFileExported"] = this.isBatchFileExported;
        return data;
    }

    clone(): BatchSummaryDto {
        const json = this.toJSON();
        let result = new BatchSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IBatchSummaryDto {
    batch_Number: string | undefined;
    processingStartTime: Date | undefined;
    processingEndTime: Date | undefined;
    executedBy: string | undefined;
    totalProducts: number | undefined;
    totalPacks: number | undefined;
    totalShipperCases: number | undefined;
    totalPallets: number | undefined;
    client: string | undefined;
    isBatchFileExported: boolean | undefined;
}

export class AjaxResponseOfBatchPackageExecutionDto implements IAjaxResponseOfBatchPackageExecutionDto {
    result: BatchPackageExecutionDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfBatchPackageExecutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? BatchPackageExecutionDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfBatchPackageExecutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfBatchPackageExecutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfBatchPackageExecutionDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfBatchPackageExecutionDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfBatchPackageExecutionDto {
    result: BatchPackageExecutionDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class BatchPackageExecutionDto implements IBatchPackageExecutionDto {
    batchNumber: string | undefined;
    packageNumber: number | undefined;
    batch_Id: string | undefined;
    batch_LotNumber: string | undefined;
    batch_ExpirationDate: Date | undefined;
    batch_SerialNumberLength: number | undefined;
    pallet_Id: string | undefined;
    pallet_SsccLeftDigit: string | undefined;
    pallet_SsccPrefix: string | undefined;
    isPalletOpen: boolean | undefined;
    pallet_ScanCount: number | undefined;
    product_Id: string | undefined;
    product_Gtin: string | undefined;
    product_ScanCount: number | undefined;
    product_MaxCount: number | undefined;
    isAllProductScaned: boolean | undefined;
    pack_Id: string | undefined;
    pack_ScanCount: number | undefined;
    pack_MaxCount: number | undefined;
    isPackScanRequired: boolean | undefined;
    pack_Gtin: string | undefined;
    isAllPackScaned: boolean | undefined;
    isPackOpen: boolean | undefined;
    shipperCase_Id: string | undefined;
    shipperCase_Gtin: string | undefined;
    shipperCase_ScanCount: number | undefined;
    isShipperCaseOpen: boolean | undefined;
    scannedValue: string | undefined;

    constructor(data?: IBatchPackageExecutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNumber = _data["batchNumber"];
            this.packageNumber = _data["packageNumber"];
            this.batch_Id = _data["batch_Id"];
            this.batch_LotNumber = _data["batch_LotNumber"];
            this.batch_ExpirationDate = _data["batch_ExpirationDate"] ? new Date(_data["batch_ExpirationDate"].toString()) : <any>undefined;
            this.batch_SerialNumberLength = _data["batch_SerialNumberLength"];
            this.pallet_Id = _data["pallet_Id"];
            this.pallet_SsccLeftDigit = _data["pallet_SsccLeftDigit"];
            this.pallet_SsccPrefix = _data["pallet_SsccPrefix"];
            this.isPalletOpen = _data["isPalletOpen"];
            this.pallet_ScanCount = _data["pallet_ScanCount"];
            this.product_Id = _data["product_Id"];
            this.product_Gtin = _data["product_Gtin"];
            this.product_ScanCount = _data["product_ScanCount"];
            this.product_MaxCount = _data["product_MaxCount"];
            this.isAllProductScaned = _data["isAllProductScaned"];
            this.pack_Id = _data["pack_Id"];
            this.pack_ScanCount = _data["pack_ScanCount"];
            this.pack_MaxCount = _data["pack_MaxCount"];
            this.isPackScanRequired = _data["isPackScanRequired"];
            this.pack_Gtin = _data["pack_Gtin"];
            this.isAllPackScaned = _data["isAllPackScaned"];
            this.isPackOpen = _data["isPackOpen"];
            this.shipperCase_Id = _data["shipperCase_Id"];
            this.shipperCase_Gtin = _data["shipperCase_Gtin"];
            this.shipperCase_ScanCount = _data["shipperCase_ScanCount"];
            this.isShipperCaseOpen = _data["isShipperCaseOpen"];
            this.scannedValue = _data["scannedValue"];
        }
    }

    static fromJS(data: any): BatchPackageExecutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchPackageExecutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        data["packageNumber"] = this.packageNumber;
        data["batch_Id"] = this.batch_Id;
        data["batch_LotNumber"] = this.batch_LotNumber;
        data["batch_ExpirationDate"] = this.batch_ExpirationDate ? this.batch_ExpirationDate.toISOString() : <any>undefined;
        data["batch_SerialNumberLength"] = this.batch_SerialNumberLength;
        data["pallet_Id"] = this.pallet_Id;
        data["pallet_SsccLeftDigit"] = this.pallet_SsccLeftDigit;
        data["pallet_SsccPrefix"] = this.pallet_SsccPrefix;
        data["isPalletOpen"] = this.isPalletOpen;
        data["pallet_ScanCount"] = this.pallet_ScanCount;
        data["product_Id"] = this.product_Id;
        data["product_Gtin"] = this.product_Gtin;
        data["product_ScanCount"] = this.product_ScanCount;
        data["product_MaxCount"] = this.product_MaxCount;
        data["isAllProductScaned"] = this.isAllProductScaned;
        data["pack_Id"] = this.pack_Id;
        data["pack_ScanCount"] = this.pack_ScanCount;
        data["pack_MaxCount"] = this.pack_MaxCount;
        data["isPackScanRequired"] = this.isPackScanRequired;
        data["pack_Gtin"] = this.pack_Gtin;
        data["isAllPackScaned"] = this.isAllPackScaned;
        data["isPackOpen"] = this.isPackOpen;
        data["shipperCase_Id"] = this.shipperCase_Id;
        data["shipperCase_Gtin"] = this.shipperCase_Gtin;
        data["shipperCase_ScanCount"] = this.shipperCase_ScanCount;
        data["isShipperCaseOpen"] = this.isShipperCaseOpen;
        data["scannedValue"] = this.scannedValue;
        return data;
    }

    clone(): BatchPackageExecutionDto {
        const json = this.toJSON();
        let result = new BatchPackageExecutionDto();
        result.init(json);
        return result;
    }
}

export interface IBatchPackageExecutionDto {
    batchNumber: string | undefined;
    packageNumber: number | undefined;
    batch_Id: string | undefined;
    batch_LotNumber: string | undefined;
    batch_ExpirationDate: Date | undefined;
    batch_SerialNumberLength: number | undefined;
    pallet_Id: string | undefined;
    pallet_SsccLeftDigit: string | undefined;
    pallet_SsccPrefix: string | undefined;
    isPalletOpen: boolean | undefined;
    pallet_ScanCount: number | undefined;
    product_Id: string | undefined;
    product_Gtin: string | undefined;
    product_ScanCount: number | undefined;
    product_MaxCount: number | undefined;
    isAllProductScaned: boolean | undefined;
    pack_Id: string | undefined;
    pack_ScanCount: number | undefined;
    pack_MaxCount: number | undefined;
    isPackScanRequired: boolean | undefined;
    pack_Gtin: string | undefined;
    isAllPackScaned: boolean | undefined;
    isPackOpen: boolean | undefined;
    shipperCase_Id: string | undefined;
    shipperCase_Gtin: string | undefined;
    shipperCase_ScanCount: number | undefined;
    isShipperCaseOpen: boolean | undefined;
    scannedValue: string | undefined;
}

export class DuplicateSerialNoCheckRequestDto implements IDuplicateSerialNoCheckRequestDto {
    packageDefinitionId: string | undefined;
    isInsideContainer: boolean | undefined;

    constructor(data?: IDuplicateSerialNoCheckRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageDefinitionId = _data["packageDefinitionId"];
            this.isInsideContainer = _data["isInsideContainer"];
        }
    }

    static fromJS(data: any): DuplicateSerialNoCheckRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateSerialNoCheckRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageDefinitionId"] = this.packageDefinitionId;
        data["isInsideContainer"] = this.isInsideContainer;
        return data;
    }

    clone(): DuplicateSerialNoCheckRequestDto {
        const json = this.toJSON();
        let result = new DuplicateSerialNoCheckRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDuplicateSerialNoCheckRequestDto {
    packageDefinitionId: string | undefined;
    isInsideContainer: boolean | undefined;
}

export class AjaxResponseOfBatchDuplicateCheckDto implements IAjaxResponseOfBatchDuplicateCheckDto {
    result: BatchDuplicateCheckDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfBatchDuplicateCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? BatchDuplicateCheckDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfBatchDuplicateCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfBatchDuplicateCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfBatchDuplicateCheckDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfBatchDuplicateCheckDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfBatchDuplicateCheckDto {
    result: BatchDuplicateCheckDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class BatchDuplicateCheckDto implements IBatchDuplicateCheckDto {
    isValid: boolean | undefined;
    isInsideContainer: boolean | undefined;
    isIdentical: boolean | undefined;
    duplicateValidationResults: DuplicateValidationResult[] | undefined;

    constructor(data?: IBatchDuplicateCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.isInsideContainer = _data["isInsideContainer"];
            this.isIdentical = _data["isIdentical"];
            if (Array.isArray(_data["duplicateValidationResults"])) {
                this.duplicateValidationResults = [] as any;
                for (let item of _data["duplicateValidationResults"])
                    this.duplicateValidationResults.push(DuplicateValidationResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchDuplicateCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDuplicateCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["isInsideContainer"] = this.isInsideContainer;
        data["isIdentical"] = this.isIdentical;
        if (Array.isArray(this.duplicateValidationResults)) {
            data["duplicateValidationResults"] = [];
            for (let item of this.duplicateValidationResults)
                data["duplicateValidationResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): BatchDuplicateCheckDto {
        const json = this.toJSON();
        let result = new BatchDuplicateCheckDto();
        result.init(json);
        return result;
    }
}

export interface IBatchDuplicateCheckDto {
    isValid: boolean | undefined;
    isInsideContainer: boolean | undefined;
    isIdentical: boolean | undefined;
    duplicateValidationResults: DuplicateValidationResult[] | undefined;
}

export class DuplicateValidationResult implements IDuplicateValidationResult {
    srNo: number | undefined;
    packageDetailId: string | undefined;
    packageDefinitionId: string | undefined;
    packageTypeClassificationValueId: string | undefined;
    parentPackageDefinitionId: string | undefined;
    scannedByUserId: number | undefined;
    scannedByUserName: string | undefined;
    readonly batchNumber: string | undefined;
    packageNumber: number | undefined;
    gtin: string | undefined;
    serialNumberSsccLabel: string | undefined;
    scanTime: Date | undefined;

    constructor(data?: IDuplicateValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.srNo = _data["srNo"];
            this.packageDetailId = _data["packageDetailId"];
            this.packageDefinitionId = _data["packageDefinitionId"];
            this.packageTypeClassificationValueId = _data["packageTypeClassificationValueId"];
            this.parentPackageDefinitionId = _data["parentPackageDefinitionId"];
            this.scannedByUserId = _data["scannedByUserId"];
            this.scannedByUserName = _data["scannedByUserName"];
            (<any>this).batchNumber = _data["batchNumber"];
            this.packageNumber = _data["packageNumber"];
            this.gtin = _data["gtin"];
            this.serialNumberSsccLabel = _data["serialNumberSsccLabel"];
            this.scanTime = _data["scanTime"] ? new Date(_data["scanTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DuplicateValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["srNo"] = this.srNo;
        data["packageDetailId"] = this.packageDetailId;
        data["packageDefinitionId"] = this.packageDefinitionId;
        data["packageTypeClassificationValueId"] = this.packageTypeClassificationValueId;
        data["parentPackageDefinitionId"] = this.parentPackageDefinitionId;
        data["scannedByUserId"] = this.scannedByUserId;
        data["scannedByUserName"] = this.scannedByUserName;
        data["batchNumber"] = this.batchNumber;
        data["packageNumber"] = this.packageNumber;
        data["gtin"] = this.gtin;
        data["serialNumberSsccLabel"] = this.serialNumberSsccLabel;
        data["scanTime"] = this.scanTime ? this.scanTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): DuplicateValidationResult {
        const json = this.toJSON();
        let result = new DuplicateValidationResult();
        result.init(json);
        return result;
    }
}

export interface IDuplicateValidationResult {
    srNo: number | undefined;
    packageDetailId: string | undefined;
    packageDefinitionId: string | undefined;
    packageTypeClassificationValueId: string | undefined;
    parentPackageDefinitionId: string | undefined;
    scannedByUserId: number | undefined;
    scannedByUserName: string | undefined;
    batchNumber: string | undefined;
    packageNumber: number | undefined;
    gtin: string | undefined;
    serialNumberSsccLabel: string | undefined;
    scanTime: Date | undefined;
}

export class PackageScanDto implements IPackageScanDto {
    batchId: string | undefined;
    packageDefinitionId: string | undefined;
    serialNumber: string | undefined;
    ssccLabel: string | undefined;

    constructor(data?: IPackageScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.packageDefinitionId = _data["packageDefinitionId"];
            this.serialNumber = _data["serialNumber"];
            this.ssccLabel = _data["ssccLabel"];
        }
    }

    static fromJS(data: any): PackageScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["packageDefinitionId"] = this.packageDefinitionId;
        data["serialNumber"] = this.serialNumber;
        data["ssccLabel"] = this.ssccLabel;
        return data;
    }

    clone(): PackageScanDto {
        const json = this.toJSON();
        let result = new PackageScanDto();
        result.init(json);
        return result;
    }
}

export interface IPackageScanDto {
    batchId: string | undefined;
    packageDefinitionId: string | undefined;
    serialNumber: string | undefined;
    ssccLabel: string | undefined;
}

export class PackageExecutionDetailSummaryDto implements IPackageExecutionDetailSummaryDto {
    id: string | undefined;
    packageNumber: number | undefined;
    batchNumber: string | undefined;
    packageType: string | undefined;
    packageStatus: string | undefined;
    gtin: string | undefined;
    maxQty: number | undefined;
    lotNumber: string | undefined;
    expirationDate: Date | undefined;
    ssccLeftDigit: string | undefined;
    ssccPrefix: string | undefined;
    senderSgln: string | undefined;
    knipperSgln: string | undefined;
    serialNumberLength: number | undefined;
    processingStation: string | undefined;
    fileNetworkPathLocation: string | undefined;
    processingStartTime: Date | undefined;
    processingEndTime: Date | undefined;
    executedBy: number | undefined;
    packageTypeClassificationId: string | undefined;
    packageStatusClassificationId: string | undefined;
    parentPackageDefinitionId: string | undefined;
    packageDetails: PackageDetailDto[] | undefined;
    subPackageDefinitions: PackageExecutionDetailSummaryDto[] | undefined;

    constructor(data?: IPackageExecutionDetailSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageNumber = _data["packageNumber"];
            this.batchNumber = _data["batchNumber"];
            this.packageType = _data["packageType"];
            this.packageStatus = _data["packageStatus"];
            this.gtin = _data["gtin"];
            this.maxQty = _data["maxQty"];
            this.lotNumber = _data["lotNumber"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.ssccLeftDigit = _data["ssccLeftDigit"];
            this.ssccPrefix = _data["ssccPrefix"];
            this.senderSgln = _data["senderSgln"];
            this.knipperSgln = _data["knipperSgln"];
            this.serialNumberLength = _data["serialNumberLength"];
            this.processingStation = _data["processingStation"];
            this.fileNetworkPathLocation = _data["fileNetworkPathLocation"];
            this.processingStartTime = _data["processingStartTime"] ? new Date(_data["processingStartTime"].toString()) : <any>undefined;
            this.processingEndTime = _data["processingEndTime"] ? new Date(_data["processingEndTime"].toString()) : <any>undefined;
            this.executedBy = _data["executedBy"];
            this.packageTypeClassificationId = _data["packageTypeClassificationId"];
            this.packageStatusClassificationId = _data["packageStatusClassificationId"];
            this.parentPackageDefinitionId = _data["parentPackageDefinitionId"];
            if (Array.isArray(_data["packageDetails"])) {
                this.packageDetails = [] as any;
                for (let item of _data["packageDetails"])
                    this.packageDetails.push(PackageDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["subPackageDefinitions"])) {
                this.subPackageDefinitions = [] as any;
                for (let item of _data["subPackageDefinitions"])
                    this.subPackageDefinitions.push(PackageExecutionDetailSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageExecutionDetailSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageExecutionDetailSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageNumber"] = this.packageNumber;
        data["batchNumber"] = this.batchNumber;
        data["packageType"] = this.packageType;
        data["packageStatus"] = this.packageStatus;
        data["gtin"] = this.gtin;
        data["maxQty"] = this.maxQty;
        data["lotNumber"] = this.lotNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["ssccLeftDigit"] = this.ssccLeftDigit;
        data["ssccPrefix"] = this.ssccPrefix;
        data["senderSgln"] = this.senderSgln;
        data["knipperSgln"] = this.knipperSgln;
        data["serialNumberLength"] = this.serialNumberLength;
        data["processingStation"] = this.processingStation;
        data["fileNetworkPathLocation"] = this.fileNetworkPathLocation;
        data["processingStartTime"] = this.processingStartTime ? this.processingStartTime.toISOString() : <any>undefined;
        data["processingEndTime"] = this.processingEndTime ? this.processingEndTime.toISOString() : <any>undefined;
        data["executedBy"] = this.executedBy;
        data["packageTypeClassificationId"] = this.packageTypeClassificationId;
        data["packageStatusClassificationId"] = this.packageStatusClassificationId;
        data["parentPackageDefinitionId"] = this.parentPackageDefinitionId;
        if (Array.isArray(this.packageDetails)) {
            data["packageDetails"] = [];
            for (let item of this.packageDetails)
                data["packageDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.subPackageDefinitions)) {
            data["subPackageDefinitions"] = [];
            for (let item of this.subPackageDefinitions)
                data["subPackageDefinitions"].push(item.toJSON());
        }
        return data;
    }

    clone(): PackageExecutionDetailSummaryDto {
        const json = this.toJSON();
        let result = new PackageExecutionDetailSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IPackageExecutionDetailSummaryDto {
    id: string | undefined;
    packageNumber: number | undefined;
    batchNumber: string | undefined;
    packageType: string | undefined;
    packageStatus: string | undefined;
    gtin: string | undefined;
    maxQty: number | undefined;
    lotNumber: string | undefined;
    expirationDate: Date | undefined;
    ssccLeftDigit: string | undefined;
    ssccPrefix: string | undefined;
    senderSgln: string | undefined;
    knipperSgln: string | undefined;
    serialNumberLength: number | undefined;
    processingStation: string | undefined;
    fileNetworkPathLocation: string | undefined;
    processingStartTime: Date | undefined;
    processingEndTime: Date | undefined;
    executedBy: number | undefined;
    packageTypeClassificationId: string | undefined;
    packageStatusClassificationId: string | undefined;
    parentPackageDefinitionId: string | undefined;
    packageDetails: PackageDetailDto[] | undefined;
    subPackageDefinitions: PackageExecutionDetailSummaryDto[] | undefined;
}

export class PackageDetailDto implements IPackageDetailDto {
    id: string | undefined;
    pacakgeDefitionId: string | undefined;
    serialnumber: string | undefined;
    ssccLabel: string | undefined;
    creationTime: Date | undefined;
    createdBy: number | undefined;

    constructor(data?: IPackageDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pacakgeDefitionId = _data["pacakgeDefitionId"];
            this.serialnumber = _data["serialnumber"];
            this.ssccLabel = _data["ssccLabel"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): PackageDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pacakgeDefitionId"] = this.pacakgeDefitionId;
        data["serialnumber"] = this.serialnumber;
        data["ssccLabel"] = this.ssccLabel;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }

    clone(): PackageDetailDto {
        const json = this.toJSON();
        let result = new PackageDetailDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDetailDto {
    id: string | undefined;
    pacakgeDefitionId: string | undefined;
    serialnumber: string | undefined;
    ssccLabel: string | undefined;
    creationTime: Date | undefined;
    createdBy: number | undefined;
}

export class AjaxResponseOfListOfDuplicateValidationResult implements IAjaxResponseOfListOfDuplicateValidationResult {
    result: DuplicateValidationResult[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfDuplicateValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(DuplicateValidationResult.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfDuplicateValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfDuplicateValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfDuplicateValidationResult {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfDuplicateValidationResult();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfDuplicateValidationResult {
    result: DuplicateValidationResult[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}